import React from "react";
import BlogField from "../Fields/BlogField";
import "../../App.css";
import Footer from "../Footer";

const Home = () => {
  return (
    <>
      <div className="mx-5">
        <div>
          <h6 className="text-center fs-italic pt-5">
            "Passion Led Us Here" . . .<br></br>{" "}
            <span className="fst-italic fw-light">
              Passion is the energy that keeps us going, that keeps us filled
              with meaning, and happiness, and excitement, and anticipation.
            </span>
          </h6>
        </div>
      </div>

      <BlogField />
  
      <Footer />
    </>
  );
};
export default Home;
